<template>
  <div>
    <div class="copyright-search-wrap table-search-top search-bar-bg">
      <input
        v-model="keyword"
        class="copyright-search"
        type="search"
        placeholder="著作者検索">
    </div>
    <p class="search-text">過去に作成した著作者情報は、以下から選択できます。</p>
    <div
      v-if="searchStatus === 1"
      class="artist-list">
      <p class="artist-not-exist">
        このキーワードの著作者は登録されていません。
      </p>
    </div>
    <div
      v-if="searchStatus === 0 || (searchStatus === -1 && authors.data.length === 0)"
      class="artist-list">
      <p class="artist-not-exist">
        著作者が登録されていません。
      </p>
    </div>
    <div
      v-if="authors.data.length > 0"
      class="artist-list">
      <a
        v-for="item in authors.data"
        :key="item.id"
        class="artist-list__item b-1"
        href="#"
        @click.prevent="onSelectAuthor(item)">
        <div class="artist-list__name">
          <span class="artist-list__name_text">
            {{ item.name_ja }}
          </span>
        </div>
      </a>
    </div>
    <pagination
      :pagination="authors"
      @on-pagination-clicked="onPaginationClicked($event)">
    </pagination>
  </div>
</template>
<script>
import Pagination from '../../../../components/Pagination'

export default {
  name: 'SearchableAuthorList',
  components: {
    Pagination,
  },
  props: {
    authors: {
      type: Object,
      default: () => {},
    },
    belongsTo: {
      type: String,
      required: true,
    },
    searchStatus: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      keyword: '',
    }
  },
  watch: {
    keyword(newSearchValue) {
      this.$emit('search', { keyword: newSearchValue, belongsTo: this.belongsTo })
    },
  },
  methods: {
    onSelectAuthor(data) {
      this.$emit('notify', { data, belongsTo: this.belongsTo })
    },
    onPaginationClicked(page) {
      this.$emit('pagination', { belongsTo: this.belongsTo, page })
    },
  },
}
</script>
<style scoped>
.b-1 {
  border: 1px solid #d4cdc8;
}

.copyright-search-wrap {
  margin-bottom: 3%;
}

.artist-list__name {
  background-color: white;
  justify-content: start;
  height: 80px;
}

.artist-list__name_text {
  color: #757575;
  text-align: left;
}

.artist-list__name:hover {
  background-color: #EEF2F4;
  border: none;
}

.artist-list__name:hover .artist-list__name_text {
  color: #ff2289;
}

.artist-list__item {
  border-radius: 5px;
}

@media screen and (max-width: 895px) {
  .artist-list {
    justify-content: center;
  }
}
.search-bar-bg {
  background: white;
}

.search-text {
  color: #757575;
  margin-bottom: 2%;
}
</style>
